
    <div class="modal-header">
  <h4 class="modal-title">{{message}}</h4>
    <button type="button" class="close" style="margin-left: 0;" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    
    <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="customerPrint()" type="button" class="btn btn-warning">Customer Receipt</button>
        <button (click)="ownPrint()" type="button" class="btn btn-info">Own Receipt</button>
        <button (click)="edit()" type="button" class="btn btn-primary">{{editText}}</button>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger m-1" (click)="dismiss()">{{ cancelText }}</button>
  </div>
    